import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton } from '@mui/material';
import { DialogActionButtons } from '../../dialogActionButtons/DialogActionButtons';
import { ModalReject } from '../modalReject/ModalReject';
import { Form } from './form/form';
import { BootstrapDialog, dialogStyles, iconButtonStyles, useStyles } from './modalVolunteerDetails.styles';
import { IPropsModalInviteOrg } from './types';

export const ModalVolunteerDetails = ({ open, setOpen, volunteer }: IPropsModalInviteOrg): JSX.Element => {
  const [visibleReject, setVisibleReject] = useState(false);
  const searchString = new URLSearchParams(window.location.search);
  const volunteerId = searchString.get('volunteerId');
  const classes = useStyles();

  const handleClose = (): void => {
    setOpen(null);
  };

  const onSubmit = ():void => {
    setVisibleReject(true);
    setOpen(null);
  };

  return (
    <>
      <div>
        <BootstrapDialog
          className={classes.modal}
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          scroll="body"
          maxWidth="lg"
        >
          <Box>
            <DialogTitle
              sx={dialogStyles}
              className={classes.modalMainTitle}
            >
              Volunteer's profile
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={iconButtonStyles}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Form volunteer={volunteer} />
            <DialogActionButtons
              submit={'Reject the user'}
              handleSubmit={onSubmit}
            />
          </Box>
        </BootstrapDialog>
      </div>
      <ModalReject
        open={visibleReject}
        setOpen={setVisibleReject}
        volunteerId={volunteerId || ''}
      />
    </>
  );
};
